import { Component, OnInit, signal, computed, effect, inject, DestroyRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.scss'],
  standalone: true,
  imports: [CommonModule]
})
export class NotFoundComponent implements OnInit {
  private destroyRef = inject(DestroyRef);
  
  pageTitle = signal('404 - Page Not Found');
  showAdditionalInfo = signal(true);
  
  displayTitle = computed(() => this.pageTitle());
  
  constructor() {
    effect(() => {
      console.log('Not found page title:', this.displayTitle());
    });
  }

  ngOnInit(): void {
  }

}
